import Box from '@mui/material/Box';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { formatDate } from '@verantos-dev/shared-utils';

import { mockConceptGroups } from '../mock/mockConceptGroups';
import { type ConceptGroup } from '../types/concept-group.types';

export const useConceptGroups = () => {
  const intl = useIntl();

  const columns: GridColDef<ConceptGroup>[] = useMemo(
    () => [
      {
        field: 'omopConceptGroupId',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.omopConceptGroupId' }),
        flex: 1,
        minWidth: 300,
      },
      {
        field: 'conceptGroupName',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.conceptGroupName' }),
        flex: 2,
        minWidth: 300,
      },
      {
        field: 'domains',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.domains' }),
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'conceptCount',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.conceptCount' }),
        flex: 1,
        minWidth: 150,
        type: 'number',
      },
      {
        field: 'owner',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.owner' }),
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'modifiedOn',
        headerName: intl.formatMessage({ id: 'conceptGroups.columns.modifiedDate' }),
        flex: 1,
        minWidth: 150,
        type: 'string',
        renderCell: (params) => {
          const modifiedOn = params.row.modifiedOn
            ? formatDate(params.row.modifiedOn.toISOString(), 'dateTimeFull')
            : '--';
          return <Box>{modifiedOn}</Box>;
        },
      },
    ],
    [intl]
  );

  const getRowId = (row: ConceptGroup) => row.omopConceptGroupId;

  const useFetchDataGridData = () => ({
    data: { data: mockConceptGroups },
    isLoading: false,
    isUninitialized: false,
  });

  return {
    columns,
    getRowId,
    useFetchDataGridData,
  };
};
